/* eslint-disable react-hooks/exhaustive-deps */
import { MdLogout, MdOutlineKeyboardBackspace } from "react-icons/md";
import { GoArrowRight } from "react-icons/go";

import { useEffect, useState } from "react";

import { BrandHeader } from "../SignUp/BrandSignUp";
import { InputField2 } from "../../../Components/Fields";
import { Button1 } from "../../../Components/Buttons";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { useBrand } from "../../../Providers/Brand";
import { useAuth } from "../../../Providers/Auth";
import { useBrandPaymentHandler } from "@/Helpers/payments/brandPayments";
import { useGeneralSettings } from "@/Providers/General";

type SubscriptionPlan = {
  _id: string;
  planType: string;
  planName: string;
  planNumberOfDays: number;
  planMaxAmount: number;
  planNetAmount: number;
  planFreeCredits: number;
  planStatus: number;
  planIsFree: boolean;
};

const numberOfMonths = { monthly: 1, quarterly: 3, yearly: 12 };

export const PricingCheckOut = () => {
  const brandState = useBrand();
  const navigate = useNavigate();
  const authState = useAuth();
  const [Amount, SetAmount] = useState(0);
  const [GST, SetGST] = useState(0);
  const generalState = useGeneralSettings();

  const [GstIN, SETGstIN] = useState("");
  const [coupon, setCoupon] = useState("");
  const [appliedCoup, setAppliedCoup] = useState(false);
  const [openCoupon, setOpenCoupon] = useState(false);

  const { handlePaymentClick, handleCouponCodeSubmit } =
    useBrandPaymentHandler();

  const query = new URLSearchParams(window.location.search);
  const [price, setPrice] = useState<number>(null);
  const [plan, SetPlan] = useState<string>(null);
  const [subscriptionType, SetSubscriptionType] = useState<string>(null);
  const [SubscriptionDays, setSubscriptionDays] = useState<number>(null);
  const [SubscriptionPlan, SetSubscriptionPlan] =
    useState<SubscriptionPlan>(null);
  const planID = query?.get("planID");

  useEffect(() => {
    async function getPlanInfo() {
      const result = await brandState?.getSubscriptionPlanById(planID);
      if (result?.success) {
        const priceToSet =
          result?.SubsciptionPlan?.planNetAmount *
          generalState?.exchangeRates["INR"] *
          numberOfMonths[result?.SubsciptionPlan?.planType];

        setPrice(priceToSet);
        SetPlan(result?.SubsciptionPlan?.planName);
        SetSubscriptionType(result?.SubsciptionPlan?.planType);
        setSubscriptionDays(result?.SubsciptionPlan?.planNumberOfDays);
        SetSubscriptionPlan(result?.SubsciptionPlan);

        const raw = localStorage.getItem("appsumocode");
        if (planID === "6814732fe4c145ec91ace5a3" && raw) {
          const { code, expiry } = JSON.parse(raw);
          const now = Date.now();

          if (now < expiry) {
            setCoupon(code);
            handleCouponCodeSubmit({
              coupon: code,
              amount: priceToSet,
              planId: planID,
              onSuccess: (result) => {
                setOpenCoupon(true);
                setAppliedCoup(true);
                setPrice(result?.netToPay);
                toast.success("AppSumo code applied successfully!", {
                  autoClose: 1500,
                });
              },
            });
          }
        }
      } else {
        toast.error(result?.Error, { autoClose: 1500 });
      }
    }
    getPlanInfo();
  }, []);

  useEffect(() => {
    SetAmount(price + (price * 18) / 100);
    SetGST((price * 18) / 100);
  }, [price]);

  const handleChange = (e) => {
    SETGstIN(e.target.value);
  };

  const onCouponSubmit = () => {
    handleCouponCodeSubmit({
      coupon: coupon,
      amount: price,
      planId: planID,
      onSuccess: (result) => {
        setAppliedCoup(true);
        setPrice(result?.netToPay);
      },
    });
  };

  const handePayment = () => {
    if (coupon !== "" && !appliedCoup) {
      alert("Verify the coupon first");
      return;
    }
    handlePaymentClick({
      paymentInfo: "SubscriptionPlanBought",
      Amount: Amount,
      subject: "Purchase Subscription",
      onSuccess: () => {
        authState?.setReFetchBrandData((prev) => !prev);
        window.open(`/Brand/pricing/checkout/success/?plan=${plan}`, "_self");
      },
      couponName: appliedCoup ? coupon : undefined,
      planID: planID,
      expireOn: Date.now() + SubscriptionDays * 24 * 60 * 60 * 1000,
      gst: GST,
    });
  };

  return (
    <>
      <BrandHeader
        text={""}
        icon={<MdLogout color="#757575" size={16} />}
        onClick={() => {
          navigate("/logout");
        }}
        visible={true}
        ButtonTextColor="#757575"
        ButtonBorderColor="#757575"
      />
      <div className="w-full h-full p-[20px] ">
        <div className="flex flex-col gap-[10px] justify-center items-center">
          <h1 className=" w-full text-[#424242] grid grid-cols-3 text-center font-[Inter] text-[30px] font-[700] ">
            <div className="text-[#757575] flex items-center justify-center  text-center font-[Inter] text-[12px] font-[400] ">
              <div
                onClick={() => navigate("/Brand/pricing")}
                className="flex justify-center items-center cursor-pointer gap-[4px]"
              >
                <MdOutlineKeyboardBackspace />
                Back to Pricing
              </div>
            </div>
            <div className="text-[#424242]  text-center font-[Inter] text-[30px] font-[700] ">
              Checkout
            </div>
            <div></div>
          </h1>
          <h2 className="text-[#757575] text-center font-[Inter] text-[16px] font-[400]">
            Review your plan details and confirm your selection
          </h2>
          <div className="w-[480px] flex flex-col pb-[20px] items-center rounded-[8px] bg-[#FFF] border-[1px] border-[#E0E0E0] ">
            <div className="w-full px-[30px] grid grid-cols-3 items-center justify-around  py-[10px]">
              <div className="text-[#424242] text-left font-[Inter] text-[14px] font-[700]">
                Selected Plan
              </div>
              <div className="text-[#424242] text-center font-[Inter] text-[14px] font-[700]">
                Plan Validity
              </div>
              <div className="text-[#424242] text-right font-[Inter] text-[14px] font-[700]">
                Amount
              </div>
            </div>
            <div className="w-full px-[30px] grid grid-cols-3 items-center justify-around  py-[10px]">
              <div className="text-[#424242] text-left font-[Inter] text-[14px] font-[400]">
                {plan}
              </div>
              <div className="text-[#424242] text-center font-[Inter] text-[14px] font-[400]">
                {subscriptionType === "yearly"
                  ? "12 Month's"
                  : subscriptionType === "quarterly"
                  ? "3 Month's"
                  : "1 Month"}
              </div>
              <div className="text-[#424242] text-right font-[Inter] text-[14px] font-[400]">{`₹${new Intl.NumberFormat(
                "en-US",
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              ).format(price)}`}</div>
            </div>
            <div className="w-full px-[30px] grid grid-cols-3 items-center justify-around  py-[10px]">
              <div className="text-[#424242] text-left font-[Inter] text-[14px] font-[400]"></div>
              <div className="text-[#424242] text-center font-[Inter] text-[14px] font-[400]">
                {"GST 18%"}
              </div>
              <div className="text-[#424242] text-right font-[Inter] text-[14px] font-[400]">{`₹${new Intl.NumberFormat(
                "en-US",
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              ).format(GST)}`}</div>
            </div>
            <div
              style={{
                width: "100%",
                height: "1px",
                background: "var(--Natural-200, #EEE)",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            ></div>
            <div className="w-full px-[30px] grid grid-cols-3 items-center justify-around  py-[10px]">
              <div className="text-[#424242] text-left font-[Inter] text-[14px] font-[400]"></div>
              <div className="text-[#424242] text-center font-[Inter] text-[14px] font-[700]">
                {"Total"}
              </div>
              <div className="text-[#424242] text-right font-[Inter] text-[14px] font-[700]">{`₹${new Intl.NumberFormat(
                "en-US",
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              ).format(Amount)}`}</div>
            </div>
            <div className="w-[90%] mt-[20px] flex items-left justify-left">
              <div>
                <InputField2
                  value={GstIN}
                  placeholder="Enter GSTIN (if any)"
                  onChange={() => {
                    handleChange(event);
                  }}
                  icon={undefined}
                />
              </div>
            </div>
            <div className="flex flex-col gap-[12px] items-center justify-center ">
              <span
                style={{ display: openCoupon ? "none" : "visible" }}
                onClick={() => setOpenCoupon(!openCoupon)}
                className="text-sm text-[#059669] mt-5 cursor-pointer "
              >
                Have a coupon code?
              </span>

              {openCoupon && (
                <section className="flex mt-5 mb-2 md:flex-row flex-col items-center md:gap-5 gap-3 w-fit">
                  <input
                    type="text"
                    placeholder="Enter Coupon Code"
                    className="py-[10px] px-5 rounded-lg text-[16px] uppercase bg-[transparent]"
                    style={{
                      border: "1px solid #A3A3A3",
                    }}
                    value={coupon}
                    onChange={(e) => {
                      setCoupon(e.target.value);
                      setAppliedCoup(false);
                      setPrice(
                        SubscriptionPlan?.planNetAmount *
                          generalState?.exchangeRates["INR"] *
                          numberOfMonths[subscriptionType]
                      );
                    }}
                  />
                  <button
                    disabled={appliedCoup}
                    className="text-[16px] border border-[#FF5C5C] text-[#FF5C5C] py-[10px] px-5 rounded-lg"
                    onClick={onCouponSubmit}
                  >
                    {appliedCoup ? "Applied" : "Apply Code"}
                  </button>
                </section>
              )}
              <span
                className={`text-[#059669] text-[16px] -mt-4 ${
                  appliedCoup ? "visible" : "hidden"
                }`}
              >
                Coupon applied successfully
              </span>
            </div>
            <div className="mt-[40px]">
              <Button1
                text={"CONTINUE TO PAY"}
                onClick={() => handePayment()}
                icon={undefined}
                rightIcon={<GoArrowRight />}
                background={undefined}
                textColor={undefined}
                borderColor={undefined}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
